import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import HeroSection from '../components/sections/HeroSection';
import PopularToursSection from '../components/sections/PopularToursSection';
import DestinationsSection from '../components/sections/DestinationsSection';
import JourneyCarouselSection from '../components/sections/JourneyCarouselSection';
import AboutSection from '../components/sections/AboutSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import BackToTop from '../components/common/BackToTop';

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <>
      <Helmet>
        <title>NomadTrailz - Premium Travel & Trekking Tours Across India</title>
        <meta name="description" content="Discover 46+ premium travel packages across India with NomadTrailz. Book weekend trips, trekking adventures, Panch Kailash, Panch Kedar, Leh Ladakh tours." />
        <meta name="keywords" content="travel india, trekking tours, weekend trips, panch kailash, panch kedar, leh ladakh, spiti valley, meghalaya, kerala, kashmir, adventure travel" />
      </Helmet>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <HeroSection />
        <PopularToursSection />
        <DestinationsSection />
        <JourneyCarouselSection />
        <AboutSection />
        <TestimonialsSection />
      </motion.div>

      <BackToTop isVisible={isVisible} />
    </>
  );
};

export default Home;
